import { hasFlag } from "country-flag-icons";

const platformBadges: Readonly<Record<string, string>> = {
  amazon_sp: "a",
  shopee: "S",
  shopify: "S",
  shoplazza: "SL",
};

export function storeCountryIdentity(region: string) {
  const source = region.trim().toUpperCase();
  const code = source === "UK" ? "GB" : source;
  if (!/^[A-Z]{2}$/u.test(code) || !hasFlag(code)) {
    return { code: "", label: region.trim() || "市场未标注" };
  }
  return {
    code,
    label: new Intl.DisplayNames(["zh-CN"], { type: "region" }).of(code) ?? code,
  };
}

export function storePlatformBadge(provider: string) {
  if (provider === "tiktok_shop") return "";
  return platformBadges[provider] ?? provider.slice(0, 2).toUpperCase();
}
